import React from 'react';
import { Button, Stack } from '@mui/material';
import SearchableSelectableTable from '../adminComponents/searchabletable';
import client from '../../../../../API';

const cols = [
  { key: 'email',          label: 'Email' },
  { key: 'first_name',     label: 'First Name' },
  { key: 'status',         label: 'Status' },
  { key: 'phone',          label: 'Phone' },
  { key: 'last_proposal',  label: 'Last Proposal' },
  { key: 'contact_source', label: 'Source' },
  { key: 'last_contacted', label: 'Last Contacted',
    render: (r) => new Date(r.last_contacted).toLocaleDateString() },
  { key: 'next_reminder',  label: 'Next Reminder',
    render: (r) => new Date(r.next_reminder).toLocaleDateString() },
];

export default function CRMTable({ onSelectionChange }) {
  const toolbar = (
    <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
      <Button size="small" variant="contained">CSV</Button>
      <Button size="small" variant="contained" color="secondary">
        Unsubscribe
      </Button>
    </Stack>
  );

  return (
    <SearchableSelectableTable
      queryFn={client.crm.contacts}
      columns={cols}
      onSelectionChange={onSelectionChange}
      toolbar={toolbar}
    />
  );
}
